export default "__VITE_ASSET__Di885J0Y__"